import useMount from '@src/utils/hooks/use-mount';
// import { jumpPage } from '@src/utils/common-util';
import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';

class LeftOpenBoxStore {
  // 列表点击回调
  @observable listClickCallback = noop;

  @observable isLeftTitleOpen = null;

  @observable data = [];

  @observable scrollContainer = null;

  // 滚动到底部的回调（外部可自定义）
  @observable scrollToBottomCallback = noop;

  _handleScrollDebounce = null;

  @observable maodianid = '';

  @observable isShowBtn = false;

  constructor(props = {}) {
    Object.assign(this, { ...props });
    this._handleScrollDebounce = debounce(this.handleScroll, 300);
  }

  //设置滚动容器ref
  setScrollContainer = container => {
    this.scrollContainer = container;
    if (container) {
      // 绑定滚动事件（改用下划线属性）
      container.addEventListener('scroll', this._handleScrollDebounce);
    }
  };

  /**
   * 滚动事件处理核心逻辑
   */
  handleScroll = () => {
    if (!this.scrollContainer) return;

    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;
    // 判断是否滚动到底部（预留200px容差，避免因精度问题触发不灵敏）
    const isBottom = scrollTop + clientHeight >= scrollHeight - 200;

    this.isShowBtn = scrollTop > clientHeight / 2;

    if (isBottom) {
      // 触发底部回调
      this.scrollToBottomCallback();
    }
  };

  /**
   * 跳转到详情页
   */
  toDetail = (item, index) => {
    this.listClickCallback(item, index);
  };

  // 销毁滚动事件（避免内存泄漏）
  destroyScrollListener = () => {
    if (this.scrollContainer && this._handleScrollDebounce) {
      // 移除事件监听（改用下划线属性）
      this.scrollContainer.removeEventListener('scroll', this._handleScrollDebounce);
    }
    // 取消防抖队列中的任务（改用下划线属性）
    this._handleScrollDebounce?.cancel();
  };

  handleClick = id => {
    const element = document.getElementById(id);
    if (element) {
      // element.scrollIntoView({ behavior: 'smooth' });
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  use() {
    useMount(async () => {
      // 组件卸载时销毁滚动监听
      return () => {
        this.destroyScrollListener();
      };
    });
    useEffect(
      () => {
        if (this.maodianid) {
          this.handleClick(this.maodianid);
        }
      },
      [this.maodianid]
    );
  }
}

export default LeftOpenBoxStore;
